/**
 * External Dependencies
 */
import 'jquery';

import './components/responsive';

// import MMENU
import 'mmenu-js';
import './components/menu';

import AOS from 'aos'; // Animate On Scroll

// import Swiper JS
import Swiper from 'swiper/bundle';
// import Swiper styles
import 'swiper/css/bundle';

$(() => {
  // Test
  console.log('Hello js world !');

  // Javascript to toggle hamburger menu
  /* document.getElementById('nav-toggle').onclick = function () {
    document.getElementById('nav-content').classList.toggle('hidden');
  }; */

  //WOW JS
  // const wow = new Wow();
  // wow.init();

  //////////////////////
  // AXEPTIO //
  /////////////////////

  window._axcb = window._axcb || [];
  window._axcb.push(function(sdk){

    console.log('axeptio SDK - loaded');

    $('.axeptio').on('click touch', function(){
      sdk.openCookies();
    });
  });

  // Init AOS //
  AOS.init({
    //disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
    disable: 'mobile',
    animatedClassName: 'aos-animate', // class applied on animation
  });
  console.log('[lib] > Animate On Scroll loaded');

  //MMENU JS
  document.addEventListener(
    "DOMContentLoaded", () => {
      new Mmenu( "#my-menu" );
    }
  );

  $(".section").addClass("wow animate__animated animate__fadeInLeft");
  $(".btn-anim").addClass("wow animate__animated animate__fadeInLeft");
  $(".noanim").removeClass("wow animate__fadeInDown animate__fadeInLeft animate__fadeInRight");

  //SWIPE JS
  var swiper = new Swiper(".mySwiper", {
    slidesPerView: 2,
    spaceBetween: 30,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
      reverseDirection: true,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    // Responsive
    breakpoints: {
      576: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 40,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 50,
      },
    },
  });

  // CLIC SUR LES CARDS //
  $('.card').on('click', function () {
    document.location.href = $(this).find('a').attr('href');
  });

  // FIXED HEADER //
  function check_header(){
    if ($(window).scrollTop() < 1 && $(window).width()>992)  {
      $("header").removeClass("second_style");
    }
    if ($(window).scrollTop() >= 1 || $(window).width()<992 ) {
      $("header").addClass("second_style");
    }
  }
  check_header();
  $(window).on("scroll", check_header);
  $(window).on("resize", check_header);

  /// SCROLL ///
  $('a[href^="#"]').addClass("scroll");

  $('.scroll').on('click touch', function () { // Au clic sur un élément
    scrollTo(this.hash, 750);
  });


  function scrollTo(page, speed) {
    $('html, body').animate({ scrollTop: $(page).offset().top - 110 }, speed); // Défilement avec un offset fixe
    return false;
  }



  // to top right away
  if ( window.location.hash ) scroll(0,0);
// void some browsers issue
  setTimeout( function() { scroll(0,0); }, 1);

  $(function() {

    // your current click function
    $('.scroll').on('click', function(e) {
      e.preventDefault();
      $('html, body').animate({
        scrollTop: $($(this).attr('href')).offset().top - 150}, 0, 'swing');
    });

    // *only* if we have anchor on the url
    if(window.location.hash) {

      // smooth scroll to the anchor id
      $('html, body').animate({
        scrollTop: $(window.location.hash).offset().top - 150}, 1000, 'swing');
    }

  });


});



